import { twMerge } from 'tailwind-merge';
interface ResultPhotoLegendProps {
  fieldText: string;
  valueText: string | React.ReactNode;
  containerClassName?: string;
}

export const ResultPhotoLegend = ({
  fieldText,
  valueText,
  containerClassName,
}: ResultPhotoLegendProps) => {
  return (
    <div className={twMerge('flex flex-wrap gap-x-1', containerClassName)}>
      <div className="text-start text-gray-600">{fieldText}</div>
      <div className="text-slate-700 break-words">{valueText}</div>
    </div>
  );
};
